import { useState } from 'react';
import { Search, Filter, X } from 'lucide-react';
import { Button } from '../../ui';

interface DocumentSearchProps {
  searchTerm: string;
  selectedCategory: string;
  categories: string[];
  onSearchChange: (term: string) => void;
  onCategoryChange: (category: string) => void;
}

export function DocumentSearch({
  searchTerm,
  selectedCategory,
  categories,
  onSearchChange,
  onCategoryChange
}: DocumentSearchProps) {
  const [showFilters, setShowFilters] = useState(false);

  const handleClearSearch = () => {
    onSearchChange('');
  };

  const handleClearCategory = () => {
    onCategoryChange('');
  };

  return (
    <div className="space-y-4">
      {/* Barre de recherche */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text"
          placeholder="Rechercher des documents..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        {searchTerm && (
          <button
            onClick={handleClearSearch}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Bouton filtres */}
      <div className="flex items-center justify-between">
        <Button
          onClick={() => setShowFilters(!showFilters)}
          variant="outline"
          size="sm"
          icon={Filter}
        >
          Filtres
          {selectedCategory && (
            <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
              1
            </span>
          )}
        </Button>

        {(searchTerm || selectedCategory) && (
          <Button
            onClick={() => {
              handleClearSearch();
              handleClearCategory();
            }}
            variant="ghost"
            size="sm"
          >
            Effacer tout
          </Button>
        )}
      </div>

      {/* Filtres par catégorie */}
      {showFilters && (
        <div className="space-y-3 p-4 bg-gray-50 rounded-lg">
          <h3 className="font-medium text-gray-900">Catégories</h3>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => onCategoryChange('')}
              className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                selectedCategory === ''
                  ? 'bg-blue-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              Toutes
            </button>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => onCategoryChange(category)}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                  selectedCategory === category
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}